/**
 * Offer Limited block entry.
 *
 * Importing the SCSS here makes Vite bundle the block's CSS alongside its JS.
 * Swiper is lazy-loaded only when the block is present on the page. GSAP is
 * lazy-loaded only when the block is present and motion is allowed.
 */

import './index.scss';

const swiperEls = document.querySelectorAll('[data-offer-limited-swiper]');

if (swiperEls.length) {
	const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	(async () => {
		const [{ default: Swiper }, { A11y, Keyboard, Navigation }] = await Promise.all([
			import('swiper'),
			import('swiper/modules'),
			import('swiper/css'),
			import('swiper/css/navigation'),
		]);

		swiperEls.forEach((el) => {
			const carousel = el.closest('.offer-limited__carousel');
			const prevEl = carousel?.querySelector('[data-offer-limited-prev]');
			const nextEl = carousel?.querySelector('[data-offer-limited-next]');

			new Swiper(el, {
				modules: [Navigation, Keyboard, A11y],
				slidesPerView: 1,
				spaceBetween: 16,
				speed: reduceMotion ? 0 : 500,
				keyboard: { enabled: true },
				a11y: { enabled: true },
				navigation: prevEl && nextEl ? { prevEl, nextEl } : false,
				breakpoints: {
					768: { slidesPerView: 2, spaceBetween: 16 },
					1024: { slidesPerView: 3, spaceBetween: 16 },
				},
			});
		});
	})();

	if (!reduceMotion) {
		document.querySelectorAll('.offer-limited').forEach((block) => {
			if (block.getBoundingClientRect().bottom > 0) {
				block.dataset.animate = '';
			}
		});

		(async () => {
			const { gsap } = await import('gsap');
			const { ScrollTrigger } = await import('gsap/ScrollTrigger');

			gsap.registerPlugin(ScrollTrigger);

			document.querySelectorAll('.offer-limited[data-animate]').forEach((block) => {
				const ctx = gsap.context(() => {
					const header = block.querySelector('.offer-limited__header');
					const slides = block.querySelectorAll('.offer-limited__slide');

					if (header) {
						gsap.to(header, {
							opacity: 1,
							y: 0,
							duration: 0.8,
							ease: 'power3.out',
							scrollTrigger: {
								trigger: block,
								start: 'top 90%',
								once: true,
							},
						});
					}

					if (slides.length) {
						gsap.to(slides, {
							opacity: 1,
							y: 0,
							duration: 0.6,
							ease: 'power3.out',
							stagger: 0.08,
							scrollTrigger: {
								trigger: block.querySelector('.offer-limited__carousel'),
								start: 'top 90%',
								once: true,
							},
						});
					}
				}, block);

				block._gsapCtx = ctx;
			});
		})();
	}
}
